// extracted by mini-css-extract-plugin
module.exports = {"theme-light":"Button_theme-light__1b-oN","theme-dark":"Button_theme-dark__3GpYR","button":"Button_button__3oXwH","iconButton":"Button_iconButton__ilyEM"};